import React from 'react';

interface Props {
    name: 'body' | 'head';
}

export default function HtmlTagName({ name }: Props) {
    return <span className="text-cerise-500">{`<${name}>`}</span>;
}
